export default ({ isDrawerOpen }) => ({ isDrawerOpen: !isDrawerOpen });



// WEBPACK FOOTER //
// ./datastore/actions/toggle-is-drawer-open.js